import { of } from 'rxjs';

export const imageHeader = {
  data$: of({
    uid: 'cmsitem_00190015',
    uuid: 'eyJpdGVtSWQiOiJjbXNpdGVtXzAwMTkwMDE1IiwiY2F0YWxvZ0lkIjoicmVudGFsTkxDb250ZW50Q2F0YWxvZyIsImNhdGFsb2dWZXJzaW9uIjoiT25saW5lIn0=',
    typeCode: 'ImageContentHeaderComponent',
    modifiedtime: '2022-11-15T14:05:48.439+01:00',
    name: 'Image Content Header',
    container: false,
    pageType: 'Image Content Header QA MOCK',
    removeBottomSpacing: true,
    synchronizationBlocked: false,
    media: {
      tablet: {
        code: 'cleanair-header-001c.jpg',
        mime: 'image/jpeg',
        altText: 'cleanair-header-001.jpg',
        url: '/medias/cleanair-header-001.jpg?context=bWFzdGVyfHJvb3R8MjIwMTU2fGltYWdlL2pwZWd8aDI2L2gwZi85MTY3NDUzMTkyMjIyL2NsZWFuYWlyLWhlYWRlci0wMDEuanBnfGZjZjM3Y2M1NTk0ZGEyYWE1ZGIxMWYyNGQ1NjU0OTlmNzllMWNiYzk4OTRkYzg0Mzk1M2EzYjI4OTkzOWFjYWU',
      },
      desktop: {
        code: 'cleanair-header-001b.jpg',
        mime: 'image/jpeg',
        altText: 'cleanair-header-001.jpg',
        url: '/medias/cleanair-header-001.jpg?context=bWFzdGVyfHJvb3R8MjIwMTU2fGltYWdlL2pwZWd8aGU3L2gwZi85MTY3NDUzMTI2Njg2L2NsZWFuYWlyLWhlYWRlci0wMDEuanBnfDhlN2NhN2VlYjNhNmQ1NTIyY2IyMmE3ZjdjNzg2ZTNjNWIyYzMxNjU2ZGE5NTU4N2FjNjdkMzNmN2JjODJkMjc',
      },
      mobile: {
        code: 'cleanair-header-001d.jpg',
        mime: 'image/jpeg',
        altText: 'cleanair-header-001.jpg',
        url: '/medias/cleanair-header-001.jpg?context=bWFzdGVyfHJvb3R8MjIwMTU2fGltYWdlL2pwZWd8aDI4L2gwYy85MTY3NDUzMjU3NzU4L2NsZWFuYWlyLWhlYWRlci0wMDEuanBnfGQ1ZDA1MGQxNjhjODQ1NTFhMGYzMjg0YmQzMDAzMWYwN2ZiOGJiMDgzZWUwZGI4YjQwODQxN2ZiNGU0NjgyMzk',
      },
      widescreen: {
        code: 'cleanair-header-001.jpg',
        mime: 'image/jpeg',
        altText: 'cleanair-header-001.jpg',
        url: '/medias/cleanair-header-001.jpg?context=bWFzdGVyfHJvb3R8MjIwMTU2fGltYWdlL2pwZWd8aGU1L2gxMi85MTY3NDUzMDYxMTUwL2NsZWFuYWlyLWhlYWRlci0wMDEuanBnfDk5MjNlMWM2OGZkOGEzMGE2ZjllYThjMjM4ZThkNzc4ZjQyNmU2NDRlMDFmYTJkMDY0ZTJlY2IwYWEyZjgxN2M',
      },
    },
    title: 'Image Content Header title QA MOCK',
  }),
};

export const backgroundHeader = {
  data$: of({
    uid: 'cmsitem_00190015',
    uuid: 'eyJpdGVtSWQiOiJjbXNpdGVtXzAwMTkwMDE1IiwiY2F0YWxvZ0lkIjoicmVudGFsTkxDb250ZW50Q2F0YWxvZyIsImNhdGFsb2dWZXJzaW9uIjoiT25saW5lIn0=',
    typeCode: 'BackgroundContentHeaderComponent',
    modifiedtime: '2022-11-15T14:05:48.439+01:00',
    name: 'Background Content Header',
    container: false,
    pageType: 'Background Content Header QA MOCK',
    removeBottomSpacing: true,
    synchronizationBlocked: false,
    title: 'Background Content Header title QA MOCK',
  }),
};
